import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import { colors } from "../../../theme";
import { Label } from "../Label/Label";
import { em } from "../../../utils";
import { breakpoints } from "../../Grid/breakpoints";

const Wrapper = styled.div`
  position: relative;
  border-bottom: ${props =>
    props.borderbottom ? `1px solid ${colors.line}` : "none"};
  margin-right: 25px;
`;

const LabelHolder = styled.div`
  position: absolute;
  top: 10px;
  left: 0px;
  z-index: 2;

  @media (min-width: ${breakpoints.md}px) {
    left: 0px;
    top: ${props => (props.large ? 23 : 20)}px;
  }
`;

const sharedStyles = css`
  width: 100%;
  margin: 0;
  border: none;
  font-size: ${em(15)};
  line-height: 1;
  font-family: "GT-Walsheim", sans-serif;
  background: transparent;
  padding: 14px 15px 0 15px;
  outline: none;

  ::placeholder {
    color: ${colors.grey};
    font-style: normal;
  }

  @media (min-width: ${breakpoints.md}px) {
    padding: 25px 25px 0 0px;
    font-size: ${props => (props.large ? em(18) : em(15))};
  }
`;

const InputStyled = styled.input`
  ${sharedStyles};
  height: 74px;

  @media (min-width: ${breakpoints.md}px) {
    height: ${props => (props.large ? 84 : 74)}px;
    padding-top: ${props => (props.large ? 20 : 25)}px;
  }
`;

const TextAreaStyled = styled.textarea`
  ${sharedStyles};
  resize: none;
  height: 150px;
  background: transparent;
  padding-top: 38px;
  line-height: 1.4;
  border: ${props => (props.error ? "1px solid red" : "none")};

  @media (min-width: ${breakpoints.md}px) {
    padding-top: ${props => (props.large ? 65 : 68)}px;
  }
`;

const MaxLength = styled.span`
  display: block;
  position: absolute;
  bottom: 10px;
  right: 15px;
  font-size: ${em(12)};
  font-weight: bold;
  color: ${colors.black};
  opacity: 0.2;
`;

class TextInput extends Component {
  static propTypes = {
    isTextArea: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    maxLength: PropTypes.number,
    value: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    grow: PropTypes.bool,
    styleControl: PropTypes.string,
    disabled: PropTypes.bool,
    borderbottom: PropTypes.bool,
    large: PropTypes.bool,
    error: PropTypes.bool
  };

  state = {
    focused: false
  };

  render() {
    const {
      isTextArea,
      label,
      name,
      maxLength,
      type,
      value,
      onFocus,
      onBlur,
      placeholder,
      onChange,
      disabled,
      borderbottom = true,
      large,
      error
    } = this.props;

    const { focused } = this.state;

    const id = isTextArea ? `txt_${name}` : `input_${name}`;
    const InputControl = isTextArea ? TextAreaStyled : InputStyled;

    return (
      <Wrapper borderbottom={borderbottom} focused={focused}>
        {label && (
          <LabelHolder large={large}>
            <Label htmlFor={id} large={large} error={error}>
              {label}
            </Label>
          </LabelHolder>
        )}

        <InputControl
          large={large}
          id={id}
          name={name}
          maxLength={maxLength}
          onChange={onChange}
          onFocus={() => {
            this.setState({ focused: true });
            if (onFocus) {
              onFocus();
            }
          }}
          onBlur={() => {
            this.setState({ focused: false });
            if (onBlur) {
              onBlur();
            }
          }}
          value={value}
          type={type}
          placeholder={placeholder}
          disabled={disabled}
        />

        {maxLength && (
          <MaxLength>
            {maxLength - value.length}/{maxLength}
          </MaxLength>
        )}
      </Wrapper>
    );
  }
}

export const TextArea = props => <TextInput isTextArea {...props} />;
export const Input = props => <TextInput {...props} />;



// WEBPACK FOOTER //
// ./src/components/Form/TextInput/TextInput.js